export default "__VITE_ASSET__L1mO1Rxw__"